import { render } from "./Mexc.vue?vue&type=template&id=52a7a744"
import script from "./Mexc.vue?vue&type=script&lang=js"
export * from "./Mexc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__